
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b4tvS", function(module, exports) {
/**
 * Product key constants, types, and lightweight helpers.
 * No icons, no 3P configs, no React components.
 */ 
var $g9Jfe = parcelRequire("g9Jfe");


var $20IWy = parcelRequire("20IWy");


var $78z3f = parcelRequire("78z3f");


var $hdfeV = parcelRequire("hdfeV");


const $6f142b1a5d666130$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    // Can't add these until they're ready as we use this type to enforce that product configs are available for all products
    Talent: 'radar'
};
const $6f142b1a5d666130$export$252aae15ddb3591c = {
    ...$6f142b1a5d666130$var$ProductKeys1P,
    Loom: 'loom',
    AtlasGoals: 'goals',
    AtlasProjects: 'projects',
    AtlasTeams: 'teams'
};
const $6f142b1a5d666130$export$ef2c0ffddaaaf76c = {
    ...$6f142b1a5d666130$var$ProductKeys1P,
    ...(0, $78z3f.ProductKeys3P)
};
const $6f142b1a5d666130$var$localAllProductKeys = Object.values($6f142b1a5d666130$export$ef2c0ffddaaaf76c);
const $6f142b1a5d666130$export$57043b2770b3924d = Object.values((0, $78z3f.ProductKeys3P));
const $6f142b1a5d666130$export$225f36a2f261b1e7 = Object.values($6f142b1a5d666130$var$ProductKeys1P);
const $6f142b1a5d666130$export$297680dde4e8aef1 = ()=>{
    if ((0, $g9Jfe.fg)('rovo_fps_use_rovo_config')) return 0, $20IWy.allProductKeys;
    return $6f142b1a5d666130$var$localAllProductKeys;
};
const $6f142b1a5d666130$export$73be91b73ebbdb05 = $6f142b1a5d666130$var$localAllProductKeys;
const $6f142b1a5d666130$export$65f9ab1ba49d5e68 = (key)=>$6f142b1a5d666130$export$225f36a2f261b1e7.includes(key);
const $6f142b1a5d666130$export$ae4856d6227d0649 = (key)=>$6f142b1a5d666130$export$57043b2770b3924d.includes(key);
const $6f142b1a5d666130$export$2a41a819c1db85b1 = (key)=>{
    if (!key) return false;
    // Check hardcoded keys first
    if ($6f142b1a5d666130$export$297680dde4e8aef1().includes(key)) return true;
    // Treat any "forge-connector-*" string as valid ProductKeys to support
    // dynamically provisioned Forge connectors without updating this constant list.
    // This means isProductKey is *looser* than "is configured in ProductKeys".
    return key.startsWith('forge-connector-');
};
const $6f142b1a5d666130$export$ba4f56e768ae6f1e = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira
];
const $6f142b1a5d666130$export$64c23f2d9ef43822 = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Atlas,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Trello,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Bitbucket,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Compass,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Focus,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Assets,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Talent,
    ...(0, $hdfeV.ProductsOrder3P)
];
const $6f142b1a5d666130$export$1d911f164123ed26 = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Github
];
const $6f142b1a5d666130$export$41ecd101a1ccdccc = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Atlas,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Trello,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Bitbucket,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Compass,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Focus,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Talent,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Assets,
    ...(0, $hdfeV.NewProductsOrder3P)
];
module.exports["ProductKeys1PForAnalytics"] = $6f142b1a5d666130$export$252aae15ddb3591c;
module.exports["ProductKeys"] = $6f142b1a5d666130$export$ef2c0ffddaaaf76c;
module.exports["all3pProductKeys"] = $6f142b1a5d666130$export$57043b2770b3924d;
module.exports["all1pProductKeys"] = $6f142b1a5d666130$export$225f36a2f261b1e7;
module.exports["getAllProductKeys"] = $6f142b1a5d666130$export$297680dde4e8aef1;
module.exports["allProductKeys"] = $6f142b1a5d666130$export$73be91b73ebbdb05;
module.exports["is1pProductKey"] = $6f142b1a5d666130$export$65f9ab1ba49d5e68;
module.exports["is3pProductKey"] = $6f142b1a5d666130$export$ae4856d6227d0649;
module.exports["isProductKey"] = $6f142b1a5d666130$export$2a41a819c1db85b1;
module.exports["productsSupportingEmptyQuery"] = $6f142b1a5d666130$export$ba4f56e768ae6f1e;
module.exports["PRODUCTS_ORDER"] = $6f142b1a5d666130$export$64c23f2d9ef43822;
module.exports["GITHUB_PRODUCT_KEYS"] = $6f142b1a5d666130$export$1d911f164123ed26;
module.exports["PRODUCTS_ORDER_WITH_3P_BY_POPULARITY"] = $6f142b1a5d666130$export$41ecd101a1ccdccc;

});

parcelRegister("hdfeV", function(module, exports) {
/**
 * Pure 3P product key constants extracted for SSR bundle isolation.
 * No icon or config imports - just string mappings.
 *
 * This is the SOURCE OF TRUTH for ProductKeys3P.
 * 3p-product-configs/index.tsx and products.tsx re-export from here.
 */ 
var $78z3f = parcelRequire("78z3f");

const $2db55438f96b7ddd$export$cc64d659abc3d135 = [
    // Loom is actually a 1P so goes to the top
    (0, $78z3f.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $78z3f.ProductKeys3P).GoogleDrive,
    (0, $78z3f.ProductKeys3P).Sharepoint,
    (0, $78z3f.ProductKeys3P).OneDrive,
    (0, $78z3f.ProductKeys3P).Dropbox,
    (0, $78z3f.ProductKeys3P).Slack,
    (0, $78z3f.ProductKeys3P).Teams,
    (0, $78z3f.ProductKeys3P).Github,
    (0, $78z3f.ProductKeys3P).Figma,
    (0, $78z3f.ProductKeys3P).GoogleCalendar,
    (0, $78z3f.ProductKeys3P).Gmail,
    (0, $78z3f.ProductKeys3P).OutlookCalendar,
    (0, $78z3f.ProductKeys3P).OutlookMail,
    (0, $78z3f.ProductKeys3P).Airtable,
    (0, $78z3f.ProductKeys3P).Smartsheet,
    (0, $78z3f.ProductKeys3P).Asana,
    (0, $78z3f.ProductKeys3P).Zendesk,
    (0, $78z3f.ProductKeys3P).Miro,
    (0, $78z3f.ProductKeys3P).Docusign,
    (0, $78z3f.ProductKeys3P).Lucid,
    (0, $78z3f.ProductKeys3P).Monday,
    (0, $78z3f.ProductKeys3P).AzureDevops,
    (0, $78z3f.ProductKeys3P).Gitlab,
    (0, $78z3f.ProductKeys3P).ConfluenceDC,
    (0, $78z3f.ProductKeys3P).Canva,
    (0, $78z3f.ProductKeys3P).Box,
    (0, $78z3f.ProductKeys3P).Zeplin,
    (0, $78z3f.ProductKeys3P).ServiceNow,
    (0, $78z3f.ProductKeys3P).Freshservice,
    (0, $78z3f.ProductKeys3P).PowerBI,
    (0, $78z3f.ProductKeys3P).ClickUp,
    (0, $78z3f.ProductKeys3P).Amplitude,
    (0, $78z3f.ProductKeys3P).Stripe,
    (0, $78z3f.ProductKeys3P).AdobeXD,
    (0, $78z3f.ProductKeys3P).Aha,
    (0, $78z3f.ProductKeys3P).AdobeSign,
    (0, $78z3f.ProductKeys3P).Mural,
    (0, $78z3f.ProductKeys3P).Webex,
    (0, $78z3f.ProductKeys3P).PagerDuty,
    (0, $78z3f.ProductKeys3P).Pipedrive,
    (0, $78z3f.ProductKeys3P).Dovetail,
    (0, $78z3f.ProductKeys3P).LaunchDarkly,
    (0, $78z3f.ProductKeys3P).Salesforce,
    (0, $78z3f.ProductKeys3P).Sentry,
    (0, $78z3f.ProductKeys3P).Gitbook,
    (0, $78z3f.ProductKeys3P).AWSS3,
    (0, $78z3f.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $78z3f.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $78z3f.ProductKeys3P).ForgePioAwsDev,
    (0, $78z3f.ProductKeys3P).ForgePioAwsProd,
    (0, $78z3f.ProductKeys3P).ForgePioClickupDev,
    (0, $78z3f.ProductKeys3P).ForgePioClickupProd,
    (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
    (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
    (0, $78z3f.ProductKeys3P).ForgePioGitbookDev,
    (0, $78z3f.ProductKeys3P).ForgePioGitbookProd,
    (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
    (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
    (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $78z3f.ProductKeys3P).ForgePioGuruDev,
    (0, $78z3f.ProductKeys3P).ForgePioGuruProd,
    (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $78z3f.ProductKeys3P).ForgePioHubspotDev,
    (0, $78z3f.ProductKeys3P).ForgePioHubspotProd,
    (0, $78z3f.ProductKeys3P).ForgePioSalesforceDev,
    (0, $78z3f.ProductKeys3P).ForgePioSalesforceProd,
    (0, $78z3f.ProductKeys3P).ForgePioSharepointDev,
    (0, $78z3f.ProductKeys3P).ForgePioSharepointProd,
    (0, $78z3f.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $78z3f.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampProd,
    // New 3P? Add it here
    (0, $78z3f.ProductKeys3P).Databricks,
    (0, $78z3f.ProductKeys3P).Notion,
    (0, $78z3f.ProductKeys3P).Todoist,
    (0, $78z3f.ProductKeys3P).Hubspot,
    (0, $78z3f.ProductKeys3P).Zoom,
    (0, $78z3f.ProductKeys3P).JiraDC,
    (0, $78z3f.ProductKeys3P).JsmDC,
    // Always last
    (0, $78z3f.ProductKeys3P).AtlassianWebCrawler
];
// TODO: QS-8075 replace into PRODUCTS_ORDER when cleaning up the FG
const $2db55438f96b7ddd$export$915acbd1d0c0550d = [
    // Loom is actually a 1P so goes to the top
    (0, $78z3f.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $78z3f.ProductKeys3P).GoogleDrive,
    (0, $78z3f.ProductKeys3P).Sharepoint,
    (0, $78z3f.ProductKeys3P).Slack,
    (0, $78z3f.ProductKeys3P).Teams,
    (0, $78z3f.ProductKeys3P).Figma,
    (0, $78z3f.ProductKeys3P).Miro,
    (0, $78z3f.ProductKeys3P).Salesforce,
    (0, $78z3f.ProductKeys3P).Github,
    (0, $78z3f.ProductKeys3P).Gmail,
    (0, $78z3f.ProductKeys3P).Gitlab,
    (0, $78z3f.ProductKeys3P).Lucid,
    (0, $78z3f.ProductKeys3P).Asana,
    (0, $78z3f.ProductKeys3P).AzureDevops,
    (0, $78z3f.ProductKeys3P).GoogleCalendar,
    (0, $78z3f.ProductKeys3P).OneDrive,
    (0, $78z3f.ProductKeys3P).Dropbox,
    (0, $78z3f.ProductKeys3P).OutlookCalendar,
    (0, $78z3f.ProductKeys3P).OutlookMail,
    (0, $78z3f.ProductKeys3P).Airtable,
    (0, $78z3f.ProductKeys3P).Smartsheet,
    (0, $78z3f.ProductKeys3P).Zendesk,
    (0, $78z3f.ProductKeys3P).Docusign,
    (0, $78z3f.ProductKeys3P).Databricks,
    (0, $78z3f.ProductKeys3P).Monday,
    (0, $78z3f.ProductKeys3P).ConfluenceDC,
    (0, $78z3f.ProductKeys3P).Canva,
    (0, $78z3f.ProductKeys3P).Box,
    (0, $78z3f.ProductKeys3P).Zeplin,
    (0, $78z3f.ProductKeys3P).ServiceNow,
    (0, $78z3f.ProductKeys3P).Freshservice,
    (0, $78z3f.ProductKeys3P).PowerBI,
    (0, $78z3f.ProductKeys3P).ClickUp,
    (0, $78z3f.ProductKeys3P).Amplitude,
    (0, $78z3f.ProductKeys3P).Stripe,
    (0, $78z3f.ProductKeys3P).AdobeXD,
    (0, $78z3f.ProductKeys3P).Aha,
    (0, $78z3f.ProductKeys3P).AdobeSign,
    (0, $78z3f.ProductKeys3P).Mural,
    (0, $78z3f.ProductKeys3P).Webex,
    (0, $78z3f.ProductKeys3P).PagerDuty,
    (0, $78z3f.ProductKeys3P).Pipedrive,
    (0, $78z3f.ProductKeys3P).Dovetail,
    (0, $78z3f.ProductKeys3P).LaunchDarkly,
    (0, $78z3f.ProductKeys3P).Sentry,
    (0, $78z3f.ProductKeys3P).Gitbook,
    (0, $78z3f.ProductKeys3P).AWSS3,
    (0, $78z3f.ProductKeys3P).Notion,
    (0, $78z3f.ProductKeys3P).Todoist,
    (0, $78z3f.ProductKeys3P).Hubspot,
    (0, $78z3f.ProductKeys3P).JiraDC,
    (0, $78z3f.ProductKeys3P).JsmDC,
    // New 3P? Add it here
    (0, $78z3f.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $78z3f.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $78z3f.ProductKeys3P).ForgePioAwsDev,
    (0, $78z3f.ProductKeys3P).ForgePioAwsProd,
    (0, $78z3f.ProductKeys3P).ForgePioClickupDev,
    (0, $78z3f.ProductKeys3P).ForgePioClickupProd,
    (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
    (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
    (0, $78z3f.ProductKeys3P).ForgePioGitbookDev,
    (0, $78z3f.ProductKeys3P).ForgePioGitbookProd,
    (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
    (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
    (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $78z3f.ProductKeys3P).ForgePioGuruDev,
    (0, $78z3f.ProductKeys3P).ForgePioGuruProd,
    (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $78z3f.ProductKeys3P).ForgePioHubspotDev,
    (0, $78z3f.ProductKeys3P).ForgePioHubspotProd,
    (0, $78z3f.ProductKeys3P).ForgePioSalesforceDev,
    (0, $78z3f.ProductKeys3P).ForgePioSalesforceProd,
    (0, $78z3f.ProductKeys3P).ForgePioSharepointDev,
    (0, $78z3f.ProductKeys3P).ForgePioSharepointProd,
    (0, $78z3f.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $78z3f.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampProd,
    (0, $78z3f.ProductKeys3P).Zoom,
    // Always last
    (0, $78z3f.ProductKeys3P).AtlassianWebCrawler
];
const $2db55438f96b7ddd$export$c36c249aaac5cad0 = {
    // TODO: when cleaning up `rovo_fps_show_github_assignee_filter`, add Github + ForgePioGithubDev/Prod here.
    assignee: [
        (0, $78z3f.ProductKeys3P).JiraDC,
        (0, $78z3f.ProductKeys3P).JsmDC
    ],
    campaignStatus: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    caseStatus: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    closeDate: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    // TODO: when cleaning up `rovo_fps_enable_gdrive_content_filter` / `rovo_fps_enable_sharepoint_content_filter`, add Google / Sharepoint here.
    content: [
        (0, $78z3f.ProductKeys3P).ConfluenceDC
    ],
    // TODO: when cleaning up `rovo_fps_show_github_created_by_filter`, add Github + ForgePioGithubDev/Prod here.
    createdBy: [
        (0, $78z3f.ProductKeys3P).ConfluenceDC,
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    label: [
        (0, $78z3f.ProductKeys3P).ConfluenceDC
    ],
    lastUpdated: [
        (0, $78z3f.ProductKeys3P).Airtable,
        (0, $78z3f.ProductKeys3P).Asana,
        (0, $78z3f.ProductKeys3P).AzureDevops,
        (0, $78z3f.ProductKeys3P).Box,
        (0, $78z3f.ProductKeys3P).ConfluenceDC,
        (0, $78z3f.ProductKeys3P).Databricks,
        (0, $78z3f.ProductKeys3P).Docusign,
        (0, $78z3f.ProductKeys3P).Dropbox,
        (0, $78z3f.ProductKeys3P).Figma,
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $78z3f.ProductKeys3P).ForgePioAwsDev,
        (0, $78z3f.ProductKeys3P).ForgePioAwsProd,
        (0, $78z3f.ProductKeys3P).ForgePioClickupDev,
        (0, $78z3f.ProductKeys3P).ForgePioClickupProd,
        (0, $78z3f.ProductKeys3P).ForgePioGitbookDev,
        (0, $78z3f.ProductKeys3P).ForgePioGitbookProd,
        (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
        (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
        (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
        (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $78z3f.ProductKeys3P).ForgePioGuruDev,
        (0, $78z3f.ProductKeys3P).ForgePioGuruProd,
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $78z3f.ProductKeys3P).ForgePioHubspotDev,
        (0, $78z3f.ProductKeys3P).ForgePioHubspotProd,
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceDev,
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceProd,
        (0, $78z3f.ProductKeys3P).ForgePioSharepointDev,
        (0, $78z3f.ProductKeys3P).ForgePioSharepointProd,
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $78z3f.ProductKeys3P).Github,
        (0, $78z3f.ProductKeys3P).Gmail,
        (0, $78z3f.ProductKeys3P).GoogleDrive,
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $78z3f.ProductKeys3P).JiraDC,
        (0, $78z3f.ProductKeys3P).JsmDC,
        (0, $78z3f.ProductKeys3P).Loom,
        (0, $78z3f.ProductKeys3P).Lucid,
        (0, $78z3f.ProductKeys3P).Miro,
        (0, $78z3f.ProductKeys3P).Notion,
        (0, $78z3f.ProductKeys3P).OneDrive,
        (0, $78z3f.ProductKeys3P).OutlookMail,
        (0, $78z3f.ProductKeys3P).Salesforce,
        (0, $78z3f.ProductKeys3P).ServiceNow,
        (0, $78z3f.ProductKeys3P).Sharepoint,
        (0, $78z3f.ProductKeys3P).Slack,
        (0, $78z3f.ProductKeys3P).Smartsheet,
        (0, $78z3f.ProductKeys3P).Teams,
        (0, $78z3f.ProductKeys3P).Zendesk,
        (0, $78z3f.ProductKeys3P).Zoom
    ],
    lastUpdatedBy: [
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    opportunityStatus: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    onlyTitleMatch: [
        (0, $78z3f.ProductKeys3P).Airtable,
        (0, $78z3f.ProductKeys3P).Asana,
        (0, $78z3f.ProductKeys3P).Box,
        (0, $78z3f.ProductKeys3P).ConfluenceDC,
        (0, $78z3f.ProductKeys3P).Databricks,
        (0, $78z3f.ProductKeys3P).Docusign,
        (0, $78z3f.ProductKeys3P).Dropbox,
        (0, $78z3f.ProductKeys3P).Github,
        (0, $78z3f.ProductKeys3P).GoogleDrive,
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $78z3f.ProductKeys3P).Miro,
        (0, $78z3f.ProductKeys3P).Notion,
        (0, $78z3f.ProductKeys3P).OneDrive,
        (0, $78z3f.ProductKeys3P).OutlookMail,
        (0, $78z3f.ProductKeys3P).Salesforce,
        (0, $78z3f.ProductKeys3P).ServiceNow,
        (0, $78z3f.ProductKeys3P).Sharepoint,
        (0, $78z3f.ProductKeys3P).Smartsheet,
        (0, $78z3f.ProductKeys3P).Zendesk,
        (0, $78z3f.ProductKeys3P).Zoom
    ],
    owner: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    project: [
        (0, $78z3f.ProductKeys3P).JiraDC,
        (0, $78z3f.ProductKeys3P).JsmDC
    ],
    pullRequestStatus: [
        (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
        (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
        (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
        (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
        (0, $78z3f.ProductKeys3P).Github,
        (0, $78z3f.ProductKeys3P).Gitlab
    ],
    // TODO: when cleaning up `rovo_fps_show_repository_filter`, add Github + ForgePioGithubDev/Prod here.
    repository: [],
    // TODO: when cleaning up `rovo_fps_show_reviewer_filter`, add Github + ForgePioGithubDev/Prod here.
    reviewer: [],
    slackChannel: [
        (0, $78z3f.ProductKeys3P).Slack
    ],
    // TODO: when cleaning up `rovo_fps_enable_gdrive_space_filter` / `rovo_fps_enable_sharepoint_space_filter`, add Google / Sharepoint here.
    space: [
        (0, $78z3f.ProductKeys3P).ConfluenceDC
    ],
    hasAttachment: [
        (0, $78z3f.ProductKeys3P).Teams
    ],
    // workspaceName is always in ThirdPartyConfigs.filters for Teams (gate controls filterIdOrdering only)
    workspaceName: [
        (0, $78z3f.ProductKeys3P).Teams
    ]
};
module.exports["ProductsOrder3P"] = $2db55438f96b7ddd$export$cc64d659abc3d135;
module.exports["NewProductsOrder3P"] = $2db55438f96b7ddd$export$915acbd1d0c0550d;
module.exports["thirdPartyFilterProducts"] = $2db55438f96b7ddd$export$c36c249aaac5cad0;

});

parcelRegister("dZJhp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1662I = parcelRequire("1662I");


var $3Klnc = parcelRequire("3Klnc");


var $5G9KX = parcelRequire("5G9KX");

const $7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY = 'quick_find_connect_apps_cooldown';
const $7d046d1f45bfe672$var$MAX_ANIMATIONS_PER_WEEK = 10;
const $7d046d1f45bfe672$var$DISMISSED_VALUE = 'dismissed';
const $7d046d1f45bfe672$var$getCurrentWeekKey = ()=>{
    const now = new Date();
    // ISO week-year + ISO week so we don't get an off-by-one across a year boundary
    // (e.g. Jan 1 can fall in the previous year's last ISO week).
    return `${(0, $3Klnc.default)(now)}_w${(0, $1662I.default)(now)}`;
};
const $7d046d1f45bfe672$var$readStore = ()=>{
    const raw = (0, $5G9KX.getLocalStorageItemAsString)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && 'count' in parsed && 'weekKey' in parsed && typeof parsed.count === 'number' && typeof parsed.weekKey === 'string') return parsed;
        return null;
    } catch  {
        // JSON parse error — degrade gracefully.
        return null;
    }
};
const $7d046d1f45bfe672$var$isDismissed = ()=>{
    return (0, $5G9KX.getLocalStorageItemAsString)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY) === $7d046d1f45bfe672$var$DISMISSED_VALUE;
};
const $7d046d1f45bfe672$var$writeStore = (store)=>{
    try {
        (0, $5G9KX.setLocalStorageItem)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY, JSON.stringify(store));
    } catch  {
    // Private browsing / storage full / quota exceeded — degrade gracefully
    // (the animation plays anyway; we just lose the count for this attempt).
    }
};
const $7d046d1f45bfe672$export$92cbac270a4be2e0 = (maxPerWeek = $7d046d1f45bfe672$var$MAX_ANIMATIONS_PER_WEEK)=>{
    const canAnimate = (0, $42omo.useCallback)(()=>{
        if ($7d046d1f45bfe672$var$isDismissed()) return false;
        const weekKey = $7d046d1f45bfe672$var$getCurrentWeekKey();
        const stored = $7d046d1f45bfe672$var$readStore();
        if (stored?.weekKey === weekKey && stored.count >= maxPerWeek) return false;
        return true;
    }, [
        maxPerWeek
    ]);
    const recordAnimation = (0, $42omo.useCallback)(()=>{
        const weekKey = $7d046d1f45bfe672$var$getCurrentWeekKey();
        const stored = $7d046d1f45bfe672$var$readStore();
        const count = stored?.weekKey === weekKey ? stored.count + 1 : 1;
        $7d046d1f45bfe672$var$writeStore({
            weekKey: weekKey,
            count: count
        });
    }, []);
    const dismissPermanently = (0, $42omo.useCallback)(()=>{
        try {
            (0, $5G9KX.setLocalStorageItem)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY, $7d046d1f45bfe672$var$DISMISSED_VALUE);
        } catch  {
        // degrade gracefully
        }
    }, []);
    return {
        canAnimate: canAnimate,
        recordAnimation: recordAnimation,
        dismissPermanently: dismissPermanently
    };
};
module.exports["useConnectAppsCooldown"] = $7d046d1f45bfe672$export$92cbac270a4be2e0;

});


//# sourceMappingURL=CompanyHubMainLayout.e7411b75.js.map
